import ReviewerRole from './permissions/ReviewerRole'
import { AuthorRole } from './permissions/AuthorRole'
import NewReviewer from './permissions/NewReviewer'
import ValuedReviewer from './permissions/ValuedReviewer'
import TopReviewer from './permissions/TopReviewer'
import DevReviewer from './permissions/DevReviewer'
import FreeAuthor from './permissions/FreeAuthor'
import ProAuthor from './permissions/ProAuthor'
import BestSellingAuthor from './permissions/BestSellingAuthor'
import Publisher from './permissions/Publisher'
import UnsetReviewer from './permissions/UnsetReviewer'
import { HasIndex } from './modules/base/HasIndex'
import AdminRole from './permissions/AdminRole'
import { bsConstants } from './module.constants'
import { PermissionService } from './permissions/permission.service'
import GrowingAuthor from './permissions/GrowingAuthor'

export interface AssignedUserPermissions {
  reviewerPerms: ReviewerRole,
  authorPerms?: AuthorRole,
  adminRole?: AdminRole
}

// Instantiate our reviewer roles
const reviewerRolePermissions: HasIndex = {
  [bsConstants.USER.ROLES.REVIEWER.UNSET]: new UnsetReviewer(),
  [bsConstants.USER.ROLES.REVIEWER.NEW]: new NewReviewer(),
  [bsConstants.USER.ROLES.REVIEWER.VALUED]: new ValuedReviewer(),
  [bsConstants.USER.ROLES.REVIEWER.TOP]: new TopReviewer(),
  [bsConstants.USER.ROLES.REVIEWER.DEV]: new DevReviewer()
}

// Instantiate our author roles
const authorRolePermissions: HasIndex = {
  free: new FreeAuthor(),
  pro: new ProAuthor(),
  growing: new GrowingAuthor(),
  bestSelling: new BestSellingAuthor(),
  publisher: new Publisher()
}

export const getPermissions = (reviewerRole: string | undefined, authorRole: string | undefined): AssignedUserPermissions => {
  // console.log('Get permissions: ', reviewerRole, authorRole)
  const permissions: AssignedUserPermissions = {
    reviewerPerms: reviewerRolePermissions[reviewerRole || bsConstants.USER.ROLES.REVIEWER.NEW]
      || reviewerRolePermissions[bsConstants.USER.ROLES.REVIEWER.NEW]
  }

  if (authorRole) {
    permissions.authorPerms = authorRole ? authorRolePermissions[authorRole] : {}
  }

  return permissions
}

export {
  ValuedReviewer,
  ReviewerRole,
  NewReviewer,
  TopReviewer,
  FreeAuthor,
  GrowingAuthor,
  ProAuthor,
  BestSellingAuthor,
  Publisher,
  PermissionService
}
